@if (feedback().length) {
  <h3-feedback-panel [dialogTitle]="title" (panelClose)="closeList()">
    <h3-feedback-list-item
      *ngFor="let item of feedback()"
      [id]="item.id"
      [feedback]="item"
      [isSelected]="selectedFeedbackId() === item.id"
    >
    </h3-feedback-list-item>
  </h3-feedback-panel>
}
